module.exports = __webpack_public_path__ + "static/img/pt.9e9c3fe.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/lang/pt.png
// module id = cbFU
// module chunks = 128